const DISPLAY_OPTIONS = new Map<string, number[]>([
    ["<5", [0, 5]],
    ["5.1-5.5", [5.1, 5.5]],
    ["5.6-6", [5.6, 6]],
    ["6.1-6.5", [6.1, 6.5]],
    ["6.6-6.8", [6.6, 6.8]],
    [">6.8", [6.8, 100]],
]);

const RAM_OPTIONS = new Map<string, number[]>([
    ["<3 GB", [0, 3]],
    ["3 GB", [2.9, 3.1]],
    ["4 GB", [3.9, 4.1]],
    ["6 GB", [5.9, 6.1]],
    ["8 GB", [7.9, 8.1]],
    ["12 GB", [11.9, 12.1]],
    [">12 GB", [12.1, 100]],
]);

const MAIN_CAMERA_OPTIONS = new Map<string, number[]>([
    ["<8 MP", [0, 8]],
    ["8-19 MP", [8, 19]],
    ["20-47 MP", [20, 47]],
    ["48-63 MP", [48, 63]],
    ["64-99 MP", [64, 99]],
    ["100 MP", [99, 101]],
    ["108 MP", [107, 109]],
    ["200 MP", [199, 201]],
]);

const FRONT_CAMERA_OPTIONS = new Map<string, number[]>([
    ["<6 MP", [0, 5.9]],
    ["6-11 MP", [6, 11]],
    ["12-15 MP", [12, 15]],
    ["16-20 MP", [16, 20]],
    ["21-30 MP", [21, 30]],
    [">30 MP", [30.1, 100]],
]);

const REFRESH_RATE_OPTIONS = new Map<string, number[]>([
    ["60 Hz", [0, 60]],
    ["90 Hz", [89, 91]],
    ["120 Hz", [119, 121]],
    ["144 Hz", [143, 145]],
    ["165+ Hz", [164, 1000]],
]);

const STORAGE_OPTIONS = new Map<string, number[]>([
    ["<64 GB", [0, 63]],
    ["64 GB", [63, 65]],
    ["128 GB", [127, 129]],
    ["256 GB", [255, 257]],
    ["512 GB", [511, 513]],
    ["1 TB", [1023, 1025]],
]);

const RELEASE_YEAR_OPTIONS = new Map<string, number[]>([
    ["2026", [2026, 2026]],
    ["2025", [2025, 2025]],
    ["2024", [2024, 2024]],
    ["2023 and older", [0, 2023]],
]);
const getRangeLabel = (key: string, range: number[]) => {
    // Map the filter key to your constant Maps
    const optionMaps: Record<string, Map<string, number[]>> = {
        screen_size: DISPLAY_OPTIONS,
        ram: RAM_OPTIONS,
        main_camera: MAIN_CAMERA_OPTIONS,
        front_camera: FRONT_CAMERA_OPTIONS,
        refresh_rate: REFRESH_RATE_OPTIONS,
        storage: STORAGE_OPTIONS,
        release_year: RELEASE_YEAR_OPTIONS,
    };

    const map = optionMaps[key];
    if (!map) return null;

    // Find the entry where the numbers match the array in our Map
    // We use [0] and [1] to ensure the range is identical
    const entry = Array.from(map.entries()).find(
        ([_, val]) => val[0] === range[0] && val[1] === range[1]
    );

    return entry ? entry[0] : null;
};

export default getRangeLabel;